export const isBlank = function (field) {
  return (!field || field.trim() === "");
}

// metadata: metadata object (field.metadata)
// source: the key of the metadata that will create the fieldName (i.e. label, content)
export const populateFieldName = (metadata, source) => {
  if (isBlank(metadata[source])) {
    return;
  }
  if (isBlank(metadata.fieldName)) {
    let fieldName = "";
    metadata[source].match(/[a-zA-Z0-9]+/g).forEach((phrase) => {
      // prevent first letter is number
      if (!fieldName) {
        phrase.match(/\d+|[a-zA-Z]+/g).forEach(item => {
          if (!fieldName && parseInt(item)) {
            return;
          }
          fieldName += item.toLowerCase();
        });
      } else {
        fieldName += phrase[0].toUpperCase() + phrase.substr(1).toLowerCase();
      }
    });
    if (!isBlank(fieldName)) {
      fieldName = fieldName[0].toLowerCase() + fieldName.substr(1);
    }
    metadata.fieldName = fieldName;
    return fieldName;
  }
}
